import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'anterasoftware-kanban-add-saved-search-modal',
  templateUrl: './kanban-add-saved-search-modal.component.html',
  styleUrls: ['./kanban-add-saved-search-modal.component.scss'],
})
export class KanbanAddSavedSearchModalComponent implements OnInit {

 public savedSearchName: FormControl = new FormControl('');
 public isShare: FormControl = new FormControl('');
 public isTab: FormControl = new FormControl('');

  constructor(public dialogRef: MatDialogRef<KanbanAddSavedSearchModalComponent>) {}

  ngOnInit(): void {}


  /**
   * Closes the dialog
   *
   * @returns {void}
   */
  public onClose() {
    this.dialogRef.close();
  }

  /**
   * On Save, emit the saved search name.
   *
   * @returns {void}
   */
  public onSave(): void{
    //const savedSearchName = this.savedSearchName.value;
    let saveSearchData = {
      name: this.savedSearchName.value,
      isShare: this.isShare.value,
      isTab: this.isTab.value,
    }
    this.dialogRef.close(saveSearchData);
  }
}
